(() => {
  const KEY = 'lbvCompare';
  const MAX = 4;

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.slice(0, MAX) : [];
    } catch (_) {
      return [];
    }
  };

  const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    sync();
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  })[char]);

  const getItem = (button) => ({
    id: button.dataset.productId || '',
    handle: button.dataset.handle || '',
    title: button.dataset.title || '',
    vendor: button.dataset.vendor || '',
    magnification: button.dataset.magnification || '—',
    optical: button.dataset.optical || '—',
    mount: button.dataset.mount || '—',
    weight: button.dataset.weight || '—',
    workingDistance: button.dataset.workingDistance || '—',
    fieldView: button.dataset.fieldView || '—',
    depthOfField: button.dataset.depthOfField || '—',
    flipUp: button.dataset.flipUp || '—',
    ttl: button.dataset.ttl || '—',
    sourceStatus: button.dataset.sourceStatus || '—'
  });

  const announce = (message) => {
    let region = document.querySelector('[data-lbv-compare-status]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'lbv-visually-hidden';
      region.dataset.lbvCompareStatus = '';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    requestAnimationFrame(() => { region.textContent = message; });
  };

  const syncButtons = (items) => {
    const ids = new Set(items.map((item) => item.id));
    document.querySelectorAll('[data-lbv-compare-add]').forEach((button) => {
      const selected = ids.has(button.dataset.productId);
      button.classList.toggle('is-selected', selected);
      button.textContent = selected ? 'Geselecteerd ✓' : (button.closest('.lbv-product-page') ? 'Toevoegen aan vergelijking' : 'Vergelijk');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  const renderTray = (items) => {
    let tray = document.querySelector('[data-lbv-compare-tray]');

    document.body.classList.toggle('has-lbv-compare-tray', items.length > 0);

    if (!items.length) {
      if (tray) tray.remove();
      return;
    }

    if (!tray) {
      tray = document.createElement('div');
      tray.dataset.lbvCompareTray = '';
      tray.className = 'lbv-compare-tray';
      document.body.appendChild(tray);
    }

    const chips = items.map((item) => `
      <button
        class="lbv-compare-tray__chip"
        type="button"
        data-lbv-remove="${escapeHtml(item.id)}"
        aria-label="${escapeHtml(item.title)} verwijderen uit vergelijking"
      >
        <span>${escapeHtml(item.vendor)}</span>
        <strong>${escapeHtml(item.title)}</strong>
        <b aria-hidden="true">×</b>
      </button>
    `).join('');

    tray.innerHTML = `
      <div class="lbv-shell lbv-compare-tray__inner">
        <div class="lbv-compare-tray__content">
          <div class="lbv-compare-tray__heading">
            <strong>Vergelijking</strong>
            <span>${items.length} van ${MAX} geselecteerd</span>
          </div>
          <div class="lbv-compare-tray__items">${chips}</div>
        </div>
        <a class="lbv-button lbv-button--primary lbv-compare-tray__cta" href="/pages/vergelijken">
          Bekijk vergelijking <span aria-hidden="true">→</span>
        </a>
      </div>`;
  };

  const renderPage = (items) => {
    const root = document.querySelector('[data-lbv-compare-page]');
    if (!root) return;
    if (!items.length) {
      root.innerHTML = '<div class="lbv-empty"><strong>Nog geen modellen geselecteerd.</strong><p>Ga naar de catalogus en kies maximaal vier modellen.</p><a class="lbv-button lbv-button--primary" href="/collections/loepbrillen">Bekijk loepbrillen</a></div>';
      return;
    }

    const cell = (item, key) => escapeHtml(item[key] || '—');
    root.innerHTML = `
      <div class="lbv-compare-summary">
        ${items.map((item) => `
          <article>
            <span>${escapeHtml(item.vendor)}</span>
            <strong>${escapeHtml(item.title)}</strong>
            <button type="button" data-lbv-remove="${escapeHtml(item.id)}">Verwijder</button>
          </article>`).join('')}
      </div>
      <div class="lbv-compare-table-wrap">
        <table class="lbv-compare-table">
          <thead><tr><th scope="col">Specificatie</th>${items.map((item) => '<th scope="col">' + escapeHtml(item.title) + '</th>').join('')}</tr></thead>
          <tbody>
            <tr><th scope="row">Merk</th>${items.map((item) => '<td>' + cell(item,'vendor') + '</td>').join('')}</tr>
            <tr><th scope="row">Vergroting</th>${items.map((item) => '<td>' + cell(item,'magnification') + '</td>').join('')}</tr>
            <tr><th scope="row">Optisch systeem</th>${items.map((item) => '<td>' + cell(item,'optical') + '</td>').join('')}</tr>
            <tr><th scope="row">Montage</th>${items.map((item) => '<td>' + cell(item,'mount') + '</td>').join('')}</tr>
            <tr><th scope="row">Gewicht</th>${items.map((item) => '<td>' + cell(item,'weight') + '</td>').join('')}</tr>
            <tr><th scope="row">Werkafstand</th>${items.map((item) => '<td>' + cell(item,'workingDistance') + '</td>').join('')}</tr>
            <tr><th scope="row">Gezichtsveld</th>${items.map((item) => '<td>' + cell(item,'fieldView') + '</td>').join('')}</tr>
            <tr><th scope="row">Scherptediepte</th>${items.map((item) => '<td>' + cell(item,'depthOfField') + '</td>').join('')}</tr>
            <tr><th scope="row">Flip-up</th>${items.map((item) => '<td>' + cell(item,'flipUp') + '</td>').join('')}</tr>
            <tr><th scope="row">TTL</th>${items.map((item) => '<td>' + cell(item,'ttl') + '</td>').join('')}</tr>
            <tr><th scope="row">Bronstatus</th>${items.map((item) => '<td>' + cell(item,'sourceStatus') + '</td>').join('')}</tr>
            <tr><th scope="row">Details</th>${items.map((item) => '<td><a href="/products/' + encodeURIComponent(item.handle) + '">Bekijk specificaties</a></td>').join('')}</tr>
          </tbody>
        </table>
      </div>
      <button class="lbv-clear-compare" type="button" data-lbv-clear>Vergelijking leegmaken</button>`;
  };

  function sync() {
    const items = read();
    document.querySelectorAll('[data-lbv-compare-count]').forEach((el) => el.textContent = items.length);
    syncButtons(items);
    renderTray(items);
    renderPage(items);
  }

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-lbv-compare-add]');
    if (add) {
      const items = read();
      const index = items.findIndex((item) => item.id === add.dataset.productId);
      if (index >= 0) {
        items.splice(index, 1);
      } else if (items.length < MAX) {
        items.push(getItem(add));
      } else {
        announce('Je kunt maximaal 4 modellen tegelijk vergelijken.');
        return;
      }
      write(items);
      announce(index >= 0 ? 'Model verwijderd uit de vergelijking.' : 'Model toegevoegd aan de vergelijking.');
      return;
    }

    const remove = event.target.closest('[data-lbv-remove]');
    if (remove) {
      write(read().filter((item) => item.id !== remove.dataset.lbvRemove));
      return;
    }

    if (event.target.closest('[data-lbv-clear]')) {
      write([]);
    }
  });

  document.addEventListener('DOMContentLoaded', sync);
})();